export default "-- ClickBench Q12\nselect searchphrase, count(*) as c\nfrom hits\nwhere searchphrase <> ''\ngroup by searchphrase\norder by c desc \nlimit 10;";